import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
  TextField,
  Button,
  Paper,
  Container,
} from "@mui/material";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import sideDesign from "../../static/Home/sideDesign.svg";

function MainContactUs() {
  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission here
  };

  return (
    <Box
      sx={{
        backgroundColor: "#F6F9FF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 5,
        marginBottom: 5,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontSize: 32,
          color: "#1A1A1A",
          fontFamily: "Barlow, sans-serif",
          marginTop: 3,
        }}
      >
        Contact Us
      </Typography>
      <Divider
        sx={{
          width: "5%",
          backgroundColor: "#025BCF",
          height: "2px",
        }}
      />
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <Grid container spacing={3}>
          <Grid item lg={6}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                variant="h6"
                sx={{
                  color: "#393939",
                  fontFamily: "Barlow, sans-serif",
                  fontWeight: 600,
                  fontSize: 18,
                }}
              >
                Connect with our Team of Experts
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#989898",
                  fontFamily: "Barlow, sans-serif",
                  fontWeight: 400,
                  fontSize: 14,
                }}
              >
                Contact us Today for a hassle-free school management experience
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignContent: "space-evenly",
                  marginTop: 3,
                  marginBottom: 4,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Barlow, sans-serif",
                    display: "flex",
                    color: "#4D4D4D",
                    marginRight: 2,
                  }}
                >
                  <PhoneOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#02388D", padding: 0.5, marginRight: 1 }}
                  />
                  +91 99711 03052
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Barlow, sans-serif",
                    display: "flex",
                    color: "#4D4D4D",
                    marginLeft: 2,
                  }}
                >
                  <MailOutlineIcon
                    fontSize="small"
                    sx={{ color: "#02388D", padding: 0.5, marginRight: 1 }}
                  />{" "}
                  schoolmidas@techhabiles.com
                </Typography>
              </Box>
              <img src={sideDesign} alt="laptop" width="475" loading="lazy" />
            </Box>
          </Grid>
          <Grid item lg={6}>
            <Paper
              sx={{
                backgroundColor: "#F6F9FF",
                border: "1px solid #ADADAD",
                borderRadius: "30px",
                width: 500,
                height: "auto",
                marginLeft: 5,
                overflow: "hidden",
              }}
            >
              <Box
                component="form"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: 4,
                  marginBottom: 4,
                  gap: 2,
                }}
                onSubmit={handleSubmit}
              >
                <TextField
                  variant="outlined"
                  placeholder="First and Last Name"
                  type="text"
                  size="small"
                  required
                  sx={{
                    fontFamily: "Barlow, sans-serif",
                    fontSize: 12,
                    width: "75%",
                    border: "2px solid #1B1B1B",
                    borderRadius: "10px",
                    backgroundColor: "#FBFBFB",
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "transparent",
                      },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px",
                      paddingLeft: "20px",
                    },
                  }}
                />
                <TextField
                  variant="outlined"
                  placeholder="Email"
                  type="email"
                  size="small"
                  required
                  sx={{
                    fontFamily: "Barlow, sans-serif",
                    fontSize: 12,
                    width: "75%",
                    border: "2px solid #1B1B1B",
                    borderRadius: "10px",
                    backgroundColor: "#FBFBFB",
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "transparent",
                      },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px",
                      paddingLeft: "20px",
                    },
                  }}
                />
                <TextField
                  variant="outlined"
                  placeholder="Phone Number"
                  size="small"
                  required
                  sx={{
                    fontFamily: "Barlow, sans-serif",
                    fontSize: 12,
                    width: "75%",
                    border: "2px solid #1B1B1B",
                    borderRadius: "10px",
                    backgroundColor: "#FBFBFB",
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "transparent",
                      },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px",
                      paddingLeft: "20px",
                    },
                  }}
                />
                <TextField
                  multiline
                  rows={2}
                  variant="outlined"
                  placeholder="Your Message"
                  size="small"
                  required
                  sx={{
                    fontFamily: "Barlow, sans-serif",
                    fontSize: 12,
                    width: "75%",
                    border: "2px solid #1B1B1B",
                    borderRadius: "10px",
                    backgroundColor: "#FBFBFB",
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "transparent",
                      },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px",
                    },
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    width: "75%",
                    fontFamily: "Barlow, sans-serif",
                    textTransform: "unset",
                    backgroundColor: "#F39300",
                    borderRadius: "10px",
                  }}
                >
                  Submit
                </Button>
                <Typography
                  align="center"
                  variant="caption"
                  sx={{
                    color: "#4D4D4D",
                    width: "75%",
                    fontFamily: "Barlow, sans-serif",
                    fontWeight: 700,
                  }}
                >
                  By clicking the ‘Submit’ button, you agree that we may contact
                  you by phone, email, or text message.
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default MainContactUs;
